export enum SeverityLevel {
  // As a standard, we only allow info and error
  //   VERBOSE = 0,
  INFORMATION = 1,
  //   WARNING = 2,
  ERROR = 3,
  //   CRITICAL = 4,
}
